import type { UiStrings } from "../types";

export const hi: UiStrings = {
  nav: {
    category: "श्रेणी",
    forYourWork: "आपके काम के लिए",
    searchPlaceholder: "300+ टूल्स खोजें...",
    heroPlaceholder: "आपके मन में क्या है?",
  },
  trustBadges: {
    noLogin: "टूल इस्तेमाल करने के लिए साइन इन ज़रूरी नहीं",
    freeUsesDaily: "रोज़ाना 10 ट्रायल उपयोग",
    filesNeverStored: "आपकी फ़ाइलें कभी सेव नहीं होतीं",
    worksAnyDevice: "किसी भी डिवाइस पर काम करता है",
    worksWhenAiBlocked: "आपकी कंपनी की AI नीति के बावजूद काम करता है",
    availableInLanguages: "कई भाषाओं में उपलब्ध",
  },
  common: {
    backToHome: "होम पर वापस जाएं",
    home: "होम",
    signIn: "साइन इन करें",
    account: "खाता",
    contact: "संपर्क करें",
    blog: "ब्लॉग",
    shareThisTool: "इस टूल को शेयर करें",
    download: "डाउनलोड करें",
    copy: "कॉपी करें",
    copied: "कॉपी हो गया",
  },
  footer: {
    tagline: "आपका ऑल-इन-वन ऑनलाइन प्रोडक्टिविटी प्लेटफ़ॉर्म। रोज़मर्रा के कामों के लिए 300+ प्रोफ़ेशनल टूल्स, प्रीमियम एप्लिकेशन और वर्कफ़्लो प्रोडक्ट।",
    company: "कंपनी",
    about: "हमारे बारे में",
    blog: "ब्लॉग",
    contact: "संपर्क करें",
    pricing: "मूल्य निर्धारण",
    privacyPolicy: "गोपनीयता नीति",
    termsOfService: "सेवा की शर्तें",
    allTools: "सभी टूल्स",
    allRightsReserved: "सर्वाधिकार सुरक्षित।",
  },
  contact: {
    title: "हमसे संपर्क करें",
    subtitle: "कोई सवाल, सुझाव, या कुछ ठीक से काम नहीं कर रहा? हमें मदद करने में खुशी होगी।",
    email: "ईमेल",
    responseTime: "जवाब देने का समय",
    responseTimeValue: "हम आमतौर पर 1-2 कार्य दिवसों के भीतर जवाब देते हैं।",
    sendEmail: "हमें ईमेल भेजें",
    billingNote: "बिलिंग संबंधी सवालों के लिए, कृपया अपने खाते से जुड़ा ईमेल पता शामिल करें।",
    whoWeAreTitle: "FreeDailyPro की संचालन कौन करता है",
    whoWeAreBody: "FreeDailyPro को DreamUSA LLC द्वारा संचालित किया जाता है, जो एक छोटा, स्वतंत्र रूप से संचालित सॉफ्टवेयर व्यवसाय है। इसके पीछे कोई बड़ी सपोर्ट टीम नहीं है -- आपका ईमेल पढ़ने और जवाब देने वाला व्यक्ति ही उन उपकरणों को बनाता और बनाए रखता है, इसलिए कभी-कभी जवाब देने में एक-दो दिन लग जाते हैं।",
    whatWeSupportTitle: "हम किसमें मदद कर सकते हैं",
    whatWeSupportBody: "300+ टूल्स में से किसी की बग रिपोर्ट, सुविधा अनुरोध, बिलिंग और सब्सक्रिप्शन संबंधी प्रश्न (रद्दीकरण और रिफंड सहित), खाता और लॉगिन समस्याएं, और क्या अच्छा काम कर रहा है इस पर सामान्य फीडबैक। यदि किसी टूल ने गलत परिणाम दिया है, तो फाइल टाइप और क्या गलत हुआ बताना इसे जल्दी ठीक करने में मदद करता है।",
  },
  home: {
    heroTitleLine1: "हर पेशेवर काम।",
    heroTitleLine2: "एक ब्राउज़र प्लेटफ़ॉर्म",
    heroSubtitle: "एक टूल इस्तेमाल करें। वर्कफ़्लो चलाएं। API और MCP से बनाएं। या हमसे अपना प्रोडक्ट बनवाएं।",
    localSignalUsedTitle: "इस डिवाइस पर इस्तेमाल किए गए",
    localSignalTryTitle: "इनमें से कोई एक आज़माएं",
    localSignalBadge: "लोकल \u00b7 इंटरनेट की ज़रूरत नहीं",
    localSignalUsedDesc: "इस डिवाइस पर इस्तेमाल किए गए टूल्स \u2014 कुछ भी आपके ब्राउज़र से बाहर नहीं गया",
    localSignalTryDesc: "इस डिवाइस पर अभी तक कोई टूल इस्तेमाल नहीं \u2014 सब कुछ यहीं, आपके ब्राउज़र में चलता है",
    corporateSafeTitle: "कॉर्पोरेट के लिए सुरक्षित",
    corporateSafeSubtitle: "आपकी कंपनी की AI नीति चाहे जो भी हो, FreeDailyPro वैसे ही काम करता है",
    corporateSafeBlockedTitle: "पूरी तरह ब्लॉक",
    corporateSafeBlockedDesc: "नेटवर्क पर किसी भी तरह के AI टूल्स की अनुमति नहीं। फिर भी FreeDailyPro का हर टूल काम करता है \u2014 कभी भी कुछ सर्वर पर अपलोड नहीं होता।",
    corporateSafeGovernedTitle: "नियंत्रित पहुंच",
    corporateSafeGovernedDesc: "सिर्फ़ अनुमोदित, जांचे हुए टूल्स के ज़रिए ही AI की अनुमति है। यहां किसी अनुमोदन की ज़रूरत नहीं \u2014 जांचने के लिए कोई बाहरी सर्वर कॉल है ही नहीं।",
    corporateSafeOpenTitle: "कोई पाबंदी नहीं",
    corporateSafeOpenDesc: "जो भी काम आए, इस्तेमाल करें। FreeDailyPro बस तेज़ है, क्योंकि यहां न कुछ अपलोड करना है, न इंतज़ार करना है।",
    corporateSafeCta: "पूरी कॉर्पोरेट-सुरक्षा जानकारी देखें \u2192",
    exploreToolkitTitle: "टूलकिट देखें",
    exploreToolkitSubtitle: "{catCount} श्रेणियों में 300+ टूल्स \u2014 एक चुनें, या बस खोजें।",
    forYourWorkTitle: "आपके असली काम के हिसाब से बनाया गया",
    forYourWorkSubtitle: "वही प्रोफ़ेशनल टूल्स, आपके असली काम के हिसाब से व्यवस्थित",
    exploreTools: "टूल्स देखें",
    seeAllRoles: "सभी {count} भूमिकाएं देखें \u2192",
    blogTitle: "ब्लॉग से",
    viewAllPosts: "सभी पोस्ट देखें",
    faqTitle: "कोई सवाल है? हमारे FAQ देखें",
    faqMoreLink: "और जवाब चाहिए? पूरा FAQ देखें \u2192",
    toolkitProseTitle: "रोज़ के काम के लिए बनाया गया प्रोफ़ेशनल टूलकिट, सिर्फ़ कभी-कभार के कामों के लिए नहीं",
    closingCtaTitle: "शॉर्टकट जोड़ना न भूलें",
    closingCtaDesc: "एक बार जोड़ें और यह हमेशा एक क्लिक दूर रहेगा \u2014 डेस्कटॉप शॉर्टकट इंस्टॉल करें या अपने फ़ोन की होम स्क्रीन पर जोड़ें, और FreeDailyPro एक नेटिव ऐप की तरह खुलेगा, बिना ब्राउज़र टैब खोजे।",
    categoriesLabel: "{count} श्रेणियां \u2192",
    viewAllCategoriesLabel: "सभी {count} श्रेणियां देखें \u2192",
    yourFavorites: "आपके पसंदीदा",
    recentlyUsed: "हाल में इस्तेमाल किए गए",
    toolkitProsePara1: "FreeDailyPro 300 से ज़्यादा रोज़मर्रा के टूल्स को एक जगह लाता है \u2014 PDF एडिटिंग, इमेज कन्वर्ज़न, वीडियो ट्रिमिंग, ऑडियो क्लीनअप, टेक्स्ट फ़ॉर्मेटिंग, और दर्जनों कैलकुलेटर \u2014 ताकि आपको हर काम के लिए अलग-अलग साइट पर न जाना पड़े। ज़्यादातर टूल्स के लिए साइन-अप की ज़रूरत नहीं, और फ़ाइल-आधारित टूल्स में रोज़ाना 10 मुफ़्त उपयोग शामिल हैं।",
    toolkitProsePara2: "हर टूल पूरी तरह आपके ब्राउज़र में चलता है। जब आप कोई PDF कंप्रेस करते हैं या किसी फ़ोटो का बैकग्राउंड हटाते हैं, तो वह फ़ाइल कभी आपकी डिवाइस से बाहर नहीं जाती \u2014 न अपलोड होती है, न किसी सर्वर पर प्रोसेस होती है, न कहीं स्टोर होती है, थोड़ी देर के लिए भी नहीं। यह कोई सीमा नहीं है, यही पूरा डिज़ाइन है: तेज़ नतीजे, और अगर फ़ाइल संवेदनशील है तो भी कोई चिंता नहीं।",
    toolkitProsePara3: "इस लोकल-फ़र्स्ट तरीके का मतलब यह भी है कि FreeDailyPro पर्सनल लैपटॉप, लॉक्ड-डाउन ऑफ़िस मशीन, या सख़्त AI नीति वाले नेटवर्क \u2014 हर जगह एक जैसा काम करता है \u2014 IT को जांचने के लिए कोई बाहरी सर्वर कॉल है ही नहीं, क्योंकि वह मौजूद ही नहीं है।",
    toolkitProsePara4: "चाहे आपको किसी रिपोर्ट के लिए PDF मर्ज करने हों, किसी लिस्टिंग के लिए इमेज रीसाइज़ करनी हो, सोशल मीडिया के लिए वीडियो क्लिप ट्रिम करनी हो, या झटपट मॉर्टगेज या टैक्स कैलकुलेशन करनी हो \u2014 FreeDailyPro हर रोज़ इस्तेमाल होने वाला टूल बनने के लिए बनाया गया है, न कि सिर्फ़ ज़रूरत पड़ने पर याद आने वाला टूल।",
    heroLaneToolsTitle: "व्यक्तिगत कामों के लिए प्रोफ़ेशनल टूल्स",
    heroLaneToolsDesc: "PDF, इमेज, वीडियो और भी बहुत कुछ -- एक काम, आपके ब्राउज़र में ही।",
    heroLaneToolsCta: "टूल्स ब्राउज़ करें",
    heroLanePremiumTitle: "बड़े कामों के लिए प्रीमियम एप्लिकेशन",
    heroLanePremiumDesc: "बहु-चरण ऐप्स: दस्तावेज़, फ़ॉर्म, प्लानर, प्रिंट और इवेंट कागज़ात।",
    heroLanePremiumCta: "एप्लिकेशन देखें",
    heroLaneWorkflowTitle: "वर्कफ़्लो प्रोडक्ट्स",
    heroLaneWorkflowDesc: "Book Writing Toolbox, Event Suite और भी बहुत कुछ -- कई चरण, एक नतीजा।",
    heroLaneWorkflowCta: "वर्कफ़्लो प्रोडक्ट्स देखें",
    heroLaneApiTitle: "API और MCP",
    heroLaneApiDesc: "अपने कोड या AI एजेंट से वही टूल्स इस्तेमाल करें।",
    heroLaneApiCta: "डेवलपर्स पेज खोलें",
    heroLaneCustomTitle: "कस्टम सॉफ़्टवेयर",
    heroLaneCustomDesc: "बताइए आपको क्या चाहिए। हम इसे एक बार की फ़ीस पर बनाते हैं, फिर आप थोड़ा मासिक उपयोग शुल्क देते हैं।",
    heroLaneCustomCta: "बनवाने का अनुरोध करें",
  },
  install: {
    desktopTitle: "डेस्कटॉप शॉर्टकट",
    desktopSubtitle: "एक क्लिक, तुरंत खुलता है",
    mobileTitle: "मोबाइल ऐप",
    mobileSubtitle: "अपनी होम स्क्रीन पर जोड़ें",
    addToHomeScreenTitle: "FreeDailyPro को अपनी होम स्क्रीन पर जोड़ें",
    iosInstructions: "Safari में शेयर आइकन पर टैप करें, फिर \"होम स्क्रीन पर जोड़ें\" चुनें।",
    genericInstructions: "अपने ब्राउज़र का मेन्यू खोलें और \"होम स्क्रीन पर जोड़ें\" या \"ऐप इंस्टॉल करें\" खोजें।",
    desktopUnavailableTitle: "इस ब्राउज़र में वन-क्लिक इंस्टॉल उपलब्ध नहीं है",
    desktopUnavailableDesc: "आप फिर भी इस पेज को बुकमार्क कर सकते हैं, या एड्रेस बार आइकन को अपने डेस्कटॉप पर खींच सकते हैं।",
    desktopSuccess: "शॉर्टकट बन गया! FreeDailyPro आइकन देखें।",
    mobileSuccess: "जुड़ गया! अपनी होम स्क्रीन पर FreeDailyPro आइकन देखें।",
  },
  toolPage: {
    proBadge: "Pro",
    usesRemainingToday: "आज {count} ट्रायल उपयोग बचे हैं",
    whatThisToolDoes: "यह टूल क्या करता है",
    proTips: "प्रो टिप्स",
    continueWith: "इसके साथ आगे बढ़ें",
    moreFromCategory: "इस श्रेणी से और",
  },
  usageStrip: {
    freeUsesPerDay: "ट्रायल: {limit} उपयोग/दिन",
    remainingToday: "आज {count} शेष",
    dayPassLabel: "विज्ञापन-मुक्त असीमित उपयोग, $1 डे पास",
    monthlyLabel: "विज्ञापन-मुक्त असीमित उपयोग, $4.99 मासिक पास",
    quickBuy: "त्वरित खरीदें",
  },
  platformsBanner: {
    title: "यह API वास्तव में कहाँ मौजूद है",
    subtitle: "यह \"जल्द आ रहा है\" वाला पेज नहीं है -- ये असली, काम कर रही लिस्टिंग हैं जिन्हें आप आज ही सब्सक्राइब या कनेक्ट कर सकते हैं।",
    postmanDetail: "तैयार अनुरोध, पूरी तरह से दस्तावेजीकृत",
    rapidApiDetail: "Rapid के मार्केटप्लेस के ज़रिए उपयोग-आधारित बिलिंग के साथ सब्सक्राइब करें",
    mcpRegistryDetail: "com.freedailypro/tools के रूप में आधिकारिक रूप से सूचीबद्ध, {mcp} टूल, एक एंडपॉइंट",
  },
  pricingBanner: {
    title: "पारदर्शी मूल्य निर्धारण",
    subtitle: "कोई छुपे हुए स्तर नहीं, कोई अप्रत्याशित सीमा नहीं -- हर प्लान की सटीक कीमत और उससे मिलने वाली सुविधाएं।",
    toolPricingTitle: "उपयोग-आधारित टूल मूल्य",
    apiPricingTitle: "उपयोग-आधारित API और MCP मूल्य",
    freeLabel: "ट्रायल",
    freeToolDetail: "Professional Tools पर 10 उपयोग/दिन, Premium Applications पर 2",
    dayPassDetail: "$1/दिन -- विज्ञापन-मुक्त, असीमित उपयोग",
    monthlyDetail: "$4.99/माह -- विज्ञापन-मुक्त, असीमित उपयोग",
    monthlySavingsNote: "एक महीने में 5 डे पास से सस्ता",
    freeApiDetail: "20,000 कॉल/माह",
    premiumDetail: "$24/माह -- 200,000 कॉल",
    ultraDetail: "$69/माह -- 750,000 कॉल",
    megaDetail: "$129/माह -- 2,000,000 कॉल + प्राथमिकता",
  },
  apiMcpBanner: {
    title: "अब API और MCP के साथ",
    description: "हमारी 200+ टूल सीधे अपने कोड से कॉल करें, या MCP के ज़रिए एक AI एजेंट कनेक्ट करें -- वही टूल, सर्वर-साइड, जब केवल ब्राउज़र काफ़ी न हो।",
    oneKey: "हर चीज़ के लिए एक कूंजी",
    restApiMcp: "REST API + MCP",
    anyLanguage: "कोई भी भाषा, कोई भी सर्वर",
    cta: "API और MCP देखें",
  },
  premiumApps: {
    title: "प्रीमियम एप्लिकेशन",
    subtitle: "एक कदम वाले उपकरण नहीं, बल्कि वास्तविक बहु-चरण एप्लिकेशन -- अलग से भी इंस्टॉल कर सकते हैं।",
    seeAll: "सभी प्रीमियम एप्लिकेशन देखें",
  },
  googleDrive: {
    openFromGoogle: "Google Drive से खोलें",
    saveToGoogle: "Google Drive में सहेजें",
    signingIn: "Google साइन-इन खुल रहा है...",
    fetching: "Google Drive से आपकी फ़ाइल ली जा रही है...",
    saving: "Google Drive में सहेजा जा रहा है...",
    saved: "Google Drive में सहेज दिया गया",
    viewInDrive: "Drive में देखें",
    popupBlocked: "आपके ब्राउज़र ने Google साइन-इन विंडो को रोक दिया। इस साइट के लिए पॉप-अप की अनुमति दें और फिर कोशिश करें।",
    cancelled: "Google साइन-इन पूरा होने से पहले बंद हो गया। कुछ भी खोला या सहेजा नहीं गया।",
    denied: "Google Drive की अनुमति नहीं दी गई, इसलिए कुछ भी खोला या सहेजा नहीं गया। फिर कोशिश करें और आपकी चुनी फ़ाइलों की अनुमति दें।",
    loadFailed: "Google तक नहीं पहुँचा जा सका। अपना कनेक्शन या कंटेंट ब्लॉकर जाँचें और फिर कोशिश करें।",
    network: "Google Drive से कनेक्शन टूट गया। कृपया फिर कोशिश करें।",
    tooLarge: "यह फ़ाइल ब्राउज़र में खोलने के लिए बहुत बड़ी है।",
    api: "Google Drive यह काम पूरा नहीं कर सका। कृपया फिर कोशिश करें।",
    largeFile: "यह फ़ाइल 50 MB से बड़ी है। इसमें अधिक समय लग सकता है या ब्राउज़र की मेमोरी कम पड़ सकती है।",
    privacyNote: "आपकी फ़ाइल आपके ब्राउज़र और Google के बीच जाती है। यह हमारे सर्वर पर नहीं भेजी जाती।",
  },
};
